export default {
  Salary: {
    Process: 'Quy trình',
    PayWage: 'Trả lương, bảo hiểm',
    PayWageBr: 'Trả lương,</br>bảo hiểm',
    SalaryAccounting: 'Hạch toán chi phí lương',
    SalaryCostAccounting: 'Hạch toán chi phí lương, BH, KPCĐ',
    SalaryCostAccountingBr: 'Hạch toán</br>chi phí lương',
    SalaryProfession: 'Nghiệp vụ lương',
    Report: 'Báo cáo',
    ViewReportAll: 'Xem tất cả báo cáo',
    VoucherFromSalaGov: 'Chứng từ trả lương, bảo hiểm',
    Payment: 'Trả lương,',
    Insuarance: 'bảo hiểm',
    Accounting: 'Hạch toán',
    SalaryCost: 'chi phí lương',
    Department: 'Phòng ban',
    Employee: 'Cán bộ',
    IncomeTax: 'Biểu thuế thu nhập',
    Disconnect: 'Ngắt kết nối',
    Connect: 'Kết nối',
    Connecting: 'Đang kết nối',
    Disconnecting: 'Đã ngắt kết nối',
    SalarySlip: 'Phiếu rút tiền kho bạc trả lương, bảo hiểm',
    PayDepositPayment: 'Chuyển khoản kho bạc trả lương, bảo hiểm',
    VoucherFromSalaGov: 'Chuyển khoản kho bạc vào tài khoản tiền gửi trả lương, bảo hiểm',
    PaymentList: 'Danh sách trả lương, bảo hiểm',
    InsuaranceAccounting: 'Hạch toán chi phí bảo hiểm',
    AccountingList: 'Danh sách hạch toán chi phí lương',
  },

  HavingConnectSalaGov: {
    List: {
      GetData: 'Lấy dữ liệu từ Salagov'
    }
  },

  Message: {
    NotSuccessConnectionTitle: 'Kết nối không thành công',
    SuccessConnectionTitle: 'Kết nối MISA SalaGov thành công',
    SuccessDisconnectionTitle: 'Ngắt kết nối thành công',
  }
};
